module.exports = __webpack_public_path__ + "static/img/1.2088406.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gwphoto/1.jpg
// module id = Rlyx
// module chunks = 1